export { default as CompanyLogo } from './logo_grazitti.png';
export { default as Cross } from './cross.svg';
export { default as CustomRegexModalIcon } from './custom_regex_modal_icon.svg';
export { default as DownArrow } from './downArrow.svg';
export { default as Help } from './help.png';
export { default as UnAuthorizedLogo } from './401.png';
export { default as ErrorFallbackImg } from './Error-NoBG.png';
export { default as PageNotFoundImg } from './404.png';
export { default as UserAvatar } from './user.svg';
export { default as NotificationBell } from './notifications-bell.svg';
export { default as InActiveRoles } from './inactive_roles.svg';
export { default as ActiveRoles } from './active_roles.svg';
export { default as InactiveChat } from './inactive_chat.svg';
export { default as ActiveChat } from './active_chat.svg';
export { default as InactiveUsers } from './inactive_users.svg';
export { default as InactiveDash } from './active_dashboard.svg';
export { default as ActiveDash } from './inactive_dashboard.svg';
export { default as ActiveUsers } from './active_users.svg';
export { default as DeleteIcon } from './delete-icon.svg';
export { default as EditIcon } from './edit-icon.svg';
export { default as GroupAdd } from './group_add.svg';
export { default as Minimize } from './minimize.svg';
export { default as SearchIcon } from './search-icon.svg';
export { default as PlusIcon } from './add-icon.svg';
export { default as ActiveSettings } from './active_settings.svg';
export { default as InactiveSettings } from './inactive_settings.svg';
export { default as LLMIcon } from './settings.svg';
export { default as ProfileIcon } from './profile.svg';
export { default as LogoutIcon } from './logout.svg';
export { default as CurrencyIcon } from './currency.svg';
export { default as DarkEditIcon } from './dark-edit-icon.svg';
export { default as ClaudeLogo } from './claude_logo.svg';
export { default as Send } from './send.svg';
export { default as Pen } from './Pen.svg';
export { default as DollarIcon } from './Dollar.svg';
export const AILogo = `${process.env.PUBLIC_URL || ''}/Favicon.png`;
export { default as CopyToClipboard } from './content_copy.svg';
export { default as OpenAILogo } from './Open AI Icon.svg';
export { default as TextFile } from './File.svg';
export { default as Dollar } from './paid.svg';
export { default as LoginBg } from './BG.png';
export { default as FormBg } from './Mask group.png';
export { default as Tick } from './check.svg';
export { default as UploadFile } from './upload.svg';
export { default as RedFlag } from './red flag.svg';
export { default as OpenAiTableLogo } from './Open_ai_logo.png';
export { default as GoogleGeminiLogo } from './Google_Gemini_logo 1.png';
export { default as MistralAiLogo } from './Mistral_ai_logo.png';
export { default as CloudFareAiLogo } from './Cloudfare_logo.png';
export { default as ClaudeAiLogo } from './Claude_logo.png';
export { default as EyeIcon } from './FeaturedEyeIcon.png';
export { default as ActiveCreateApp } from './active_app.svg';
export { default as UnActiveCreateApp } from './inactive_app.svg';
export { default as Plus } from './add (1).svg';
export { default as PlusWhite } from './add white.svg';
export { default as Trash } from './Icon.svg';
export { default as RunTestSync } from './published_with_changes.svg';
export { default as ArrowDown } from './Down-Arrow.svg';
export { default as ArrowUp } from './Up-Arrow.svg';
export { default as CustomAppLogo } from './smart_toy (1).svg';
export { default as ActiveOnboardApps } from './active_all_apps.svg';
export { default as InactiveOnboardApps } from './inactive_all_apps.svg';
export { default as SupportHeadset } from './support_headset.svg';
export { default as PublishIcon } from './publish.svg';
export { default as DateIcon } from './date.svg';
export { default as Drag } from './drag.svg';
export { default as InfoIcon } from './info.svg';
export { default as PasswordEyeIconGray } from './Eye-open-gray.svg';
export { default as PasswordEyeIconGraySlash } from './Eye-close-gray.svg';
export { default as Share } from './share.svg';
export { default as SmallGreenCheck } from './green_check_small.svg';
export { default as ArrowLeft } from './arrow_left.svg';
export { default as ArrowRight } from './arrow_right.svg';
export { default as History } from './history.svg';
export { default as PromptHistoryIcon } from './Frame 1321314634 (1).svg';
export { default as WhiteLogo } from './white grigo logo.svg';
export { default as BlueLogo } from './blue_grigo_logo.svg';
export { default as Property1Login } from './Property1Login.svg';
export { default as Property2Login } from './Property2Login.svg';
export { default as Property3Login } from './Property3Login.svg';
export { default as Property4Login } from './Property4Login.svg';
export { default as Property5Login } from './Property5Login.svg';
export { default as Property6Login } from './Property6Login.svg';
export { default as Property7Login } from './Property7Login.svg';
export { default as Property8Login } from './Property8Login.svg';
export { default as Property9Login } from './Property9Login.svg';
export { default as Property10Login } from './Property10Login.svg';
export { default as settingsIcon } from './settingsIcon.svg';
export { default as botIcon } from './models.svg';
export { default as ActiveCompare } from './active_compare.svg';
export { default as UnActiveCompare } from './inactive_compare.svg';
export { default as OpenAi } from './OpenAI.svg';
export { default as ClaudeAi } from './ClaudeAI.svg';
export { default as GeminiAi } from './GeminiAI.svg';
export { default as CrossIcon } from './crossIcon.svg';
export { default as AutoPlay } from './auto_read_play.svg';
export { default as PlayGroundSettings } from './playground_settings.svg';
export { default as InActivePlayGround } from './inactive_playground.svg';
export { default as ActivePlayGround } from './active_playground.svg';
export { default as DefaultProvider } from './default_provider.svg';
export { default as AutoMatorSettingsActive } from './automator_settings_active.svg';
export { default as AutoMatorSettingsUnActive } from './automator_settings_unactive.svg';
export { default as VerticalDots } from './vertical_dots.svg';
export { default as NewProjectModelIcon } from './new_project_icon.svg';
export { default as FlashIconFlow } from './flashIcon.svg';
export { default as PlayIconFlow } from './playIcon.svg';
export { default as PopUpSettingIcon } from './automatorSettings.svg';
export { default as OutputPopUpArrows } from './arrowsOutput.svg';
export { default as ChevronRight } from './chevron_right.svg';
export { default as WebhookIcon } from './Webhook_icon.svg';
export { default as SchedulerIcon } from './Scheduler_icon.svg';
export { default as CalendarIcon } from './edit_calendar.svg';
export { default as InstantIcon } from './Content.svg';
export { default as TriggerImageOne } from './triggerImage1.svg';
export { default as TriggerImageTwo } from './triggerImage2.svg';
export { default as RightCoolArrow } from './arrow_cool_down.svg';
export { default as AddCircle } from './add_circle.svg';
export { default as ActiveSchool } from './active_school.svg';
export { default as InActiveSchool } from './inactive_school.svg';
export { default as PublishWhite2 } from './upgrade.svg';
export { default as FolderIcon } from './folder_icon.svg';
export { default as FeaturedIcon } from './featured_icon.svg';
export { default as UploadCloudIcon } from './Upload_cloud_icon.svg';
export { default as PDFIcon } from './PDF.svg';
export { default as DownloadIcon } from './download_icon.svg';
export { default as DraftIcon } from './draft_icon.svg';
export { default as EmbeddedInactive } from './embed-default.svg';
export { default as EmbeddedActive } from './embed.svg';
export { default as GatewayIcon } from './gateway.svg';
export { default as AssistantIcon } from './assistant.svg';
export { default as ApiIcon } from './api.svg';
export { default as PromptIcon } from './prompt.svg';
export { default as MenuCircleOut } from './expand_circle_down.svg';
export { default as MessageSquare } from './message-square.svg';
export { default as WhiteTrash } from './White_trash.svg';
export { default as PinUnpin } from './pin_n_unpin.svg';
export { default as BluePin } from './keep.svg';
export { default as SearchIconWhite } from './search-icon-white.svg';
export { default as CheckCircle } from './check_circle.svg';
export { default as CancelCircle } from './cancel_circle.svg';
export { default as SystemFiles } from './system_files.svg';
export { default as GoogleFDrive } from './google_drive.svg';
export { default as AmazonS3 } from './amazon_s3.svg';
export { default as KbFolderCard } from './kb_folder_card.svg';
export { default as OrangeRotate } from './orange_rotate.svg';
export { default as AutoRenew } from './autorenew.svg';
export { default as GoogleDriveIcon } from './g_drive_kb_file.svg';
export { default as AwsS3Icon } from './aws_s3_icon.svg';
export { default as AmazonSignIn } from './amazon_sign_in.svg';
export { default as GoogleSignIn } from './google_sign_in.svg';
export { default as SuccessSyncedCheck } from './success_check_sync.svg';
export { default as FailedSyncCheck } from './failed_check_sync.svg';
export { default as SystemFilesLight } from './quickbookslight.svg';
export { default as GreenCheck } from './green_check.svg';
export { default as WebSearchIcon } from './web_search.svg';
export { default as SearchIconBlue } from './Search.svg';
export { default as ActiveBudget } from './active_budget.svg';
export { default as InactiveBudget } from './inactive_budget.svg';
export { default as ActivePii } from './active_pii.svg';
export { default as InactivePii } from './inactive_pii.svg';
export { default as GrigoLogo } from './Grigo_logo.svg';
export { default as BellIconBlue } from './bellIcon_blue.svg';
export { default as UserProfile2 } from './user_profile_2.svg';
export { default as MenuDownArrorw } from './down_arrow.svg';
export { default as NewChatLogo } from './new_chat_logo.svg';
export { default as AttachIcon } from './attach_icon.svg';
export { default as SendButtonIcon } from './Send_button_icon.svg';
export { default as ChatAgentIcon } from './chat_agent_icon.svg';
export { default as BlueSettingsIcon } from './settingBlueIcon.svg';
export { default as BrainIcon } from './brain.svg';
export { default as OverviewIcon } from './overview.svg';
export { default as AvatarLogo } from './AvatarLogo.svg';
export { default as CopyIcon } from './copy_icon.svg';
export { default as Recents } from './recents.svg';
export { default as CodeIcon } from './code.svg';
export { default as SwitchIcon } from './switch.svg';
export { default as WrenchIcon } from './Wrench.svg';
export { default as TotalUsersIcon } from './total_users.svg';
export { default as QueriesAskedIcon } from './queries_asked.svg';
export { default as TotalConsumptionIcon } from './total_consumption.svg';
export { default as ActiveUsersIcon } from './active_users.svg';
export { default as PlatformKeysIcon } from './platform_keys.svg';
export { default as GeminiAiIcon } from './gemini_ai.svg';
export { default as TotalGatewaysIcon } from './total_gateways.svg';
export { default as PlaygroundIcon } from './playground-icon.svg';
